import {
  ScreenOrientation,
  ScreenOrientationChange,
} from "@capawesome/capacitor-screen-orientation";
import { IonItem, IonList, IonModal } from "@ionic/react";
import React, { useCallback, useContext, useEffect, useState } from "react";
import { isLandscapeMode, setScreenOrientation } from "../util/Device";
import {
  getCreateWorkOrderRoute,
  getOpenWorkOrdersRoute,
} from "../util/EquipmentHelper";
import { TranslationsContext } from "../util/Translations";
import InventoryDetailsModel from "../components/InventoryDetailsModel";
import { encodeParam } from "../util/ApiHelper";

type Props = {
  isOpen: boolean;
  onDismiss: () => void;
  partType?: number;
  isRequester: boolean;
  equipmentId: string;
  part: string;
};

const EquipmentHierarchyPartActionBar: React.FC<Props> = (props) => {
  const {
    isOpen,
    onDismiss,
    partType = 1,
    isRequester,
    equipmentId,
    part,
  } = props;
  const [landscapeMode, setLandscapeMode] = useState(false);
  const [isDetailOpen, setIsDetailOpen] = useState(false);
  const { translations } = useContext(TranslationsContext);

  useEffect(() => {
    ScreenOrientation.addListener(
      "screenOrientationChange",
      async (orientationChange: ScreenOrientationChange) => {
        await setScreenOrientation(orientationChange.type);
        const isLandscape = await isLandscapeMode(orientationChange.type);
        setLandscapeMode(isLandscape);

        //update the breakpoint to reflect the change in orientation
        (
          document.getElementById("actionBarModal") as HTMLIonModalElement
        ).setCurrentBreakpoint(isLandscape ? 0.8 : 0.4);
      }
    );
  }, []);

  const getItemDetails = useCallback(async () => {
    onDismiss();
    setIsDetailOpen(true);
  }, [onDismiss]);

  return (
    <>
      <IonModal
        id="actionBarModal"
        isOpen={isOpen}
        backdropDismiss={true}
        handle={true}
        breakpoints={[0, 0.4, 0.6, 0.8, 1]}
        initialBreakpoint={landscapeMode ? 0.8 : 0.4}
        onDidDismiss={onDismiss}
      >
        <IonList class="ion-padding-vertical">
          {partType === 1 && (
            <>
              <IonItem
                onClick={onDismiss}
                button
                detail
                routerLink={getCreateWorkOrderRoute(isRequester, equipmentId)}
              >
                {translations["lbl_mob_quick_wo_entry"] ||
                  "Quick Work Order Entry"}
              </IonItem>
              <IonItem
                onClick={onDismiss}
                button
                detail
                routerLink={getOpenWorkOrdersRoute(isRequester, equipmentId)}
              >
                {translations["lbl_mob_open_work_orders_for_equipment"] ||
                  "Open Work Orders for Equipment"}
              </IonItem>
              <IonItem
                onClick={onDismiss}
                button
                detail
                routerLink={`/work-order/equipment/${encodeParam(
                  equipmentId
                )}/${partType}/true/true/false`}
              >
                {translations[
                  "lbl_mob_open_work_orders_for_equipment_and_children"
                ] || "Open Work Orders for Equipment And Children"}
              </IonItem>
              <IonItem
                onClick={onDismiss}
                button
                detail
                routerLink={`/work-order/equipment/${encodeParam(
                  equipmentId
                )}/${partType}/false/false/false`}
              >
                {translations["lbl_mob_complete_work_orders_for_equipment"] ||
                  "Completed Work Orders for Equipment"}
              </IonItem>
              <IonItem
                onClick={onDismiss}
                button
                detail
                routerLink={`/work-order/equipment/${encodeParam(
                  equipmentId
                )}/${partType}/false/true/false`}
              >
                {translations[
                  "lbl_mob_complete_work_orders_for_equipment_and_children"
                ] || "Completed Work Orders for Equipment And Children"}
              </IonItem>
              <IonItem
                onClick={onDismiss}
                button
                detail
                routerLink={`/work-order/equipment/${encodeParam(
                  equipmentId
                )}/${partType}/false/false/true`}
              >
                {translations["lbl_mob_pm_schedules_for_equipment"] ||
                  "PM Schedules for Equipment"}
              </IonItem>
              <IonItem
                onClick={onDismiss}
                button
                detail
                routerLink={`/Equipment/${encodeParam(equipmentId)}`}
              >
                {translations["lbl_details"] || "Details"}
              </IonItem>
            </>
          )}
          {partType === 5 && (
            <IonItem onClick={getItemDetails} button detail>
              {translations["lbl_details"] || "Details"}
            </IonItem>
          )}
        </IonList>
      </IonModal>
      <InventoryDetailsModel
        item={part}
        isOpen={isDetailOpen}
        onClose={() => setIsDetailOpen(false)}
      />
    </>
  );
};

export default EquipmentHierarchyPartActionBar;
